import api from '../api';

export class SearchBarApiService {
  static async getSearchInfo(url: any) {
    return api.getApiCall(url);
  }
}
